<template>
  <div>
    <validation-observer ref="observer">
      <v-container>
        <v-card class="pa-8 mx-auto" max-width="900">
          <!-- タイトル -->
          <v-row class="mb-6">
          <v-col class="text-center">
            <h2 class="text-h5 font-weight-bold mb-2">
              JWNET加入申込（団体加入用)
            </h2>
            <h3 class="text-h6">
              兼JWNET-EDI連携サービス申込画面
            </h3>
          </v-col>
        </v-row>

        <!-- 説明文 -->
        <v-row class="mb-6">
          <v-col>
            <p class="mb-2">
              公益財団法人日本産業廃棄物処理振興センター(以下、JWセンターという。)の「電子マニフェスト加入規約」及び添付の
            </p>
            <p class="mb-2">
              「ＪＷＮＥＴ－ＥＤＩ連携サービス利用規約」に承諾し、DXE株式会社を利用代表者としてJWセンターが提供するJWNETサービスに申し込みます。
            </p>
            <p>
              電子マニフェスト加入規約
              <a href="https://www.jwnet.or.jp/jwnet/youshiki/procedure/kiyaku.html" target="_blank">
                [https://www.jwnet.or.jp/jwnet/youshiki/procedure/kiyaku.html]
              </a>
            </p>
          </v-col>
        </v-row>

        <v-form ref="form" v-model="valid">
          <!-- JWNET登録事業者名 -->
          <v-row>
            <v-col cols="12">
              <v-row align="center">
                <v-col cols="12" md="3">
                  <strong>JWNET登録事業者名</strong>
                </v-col>
                <v-col cols="12" md="9" class="mt-0 pa-0">
                  <span class="text-body-1">{{ jwnetName }}</span>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" md="3">
                </v-col>
                <v-col cols="12" md="9" class="mt-0 pa-0">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ required: true }"
                    name="JWNET登録事業者名"
                    class="requiredMark"
                  >
                    <v-select
                      v-model="form.corporation_code"
                      :items="corporationTypes"
                      :error-messages="errors"
                      outlined
                      dense
                      label=" "
                      placeholder="選択してください"
                      persistent-placeholder
                    >
                      <template v-slot:append>
                        <v-icon>mdi-chevron-down</v-icon>
                      </template>
                    </v-select>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- 事業者名の表示順 -->
          <v-row class="mt-0">
            <v-col cols="12" md="3">
            </v-col>
            <v-col cols="12" md="9" class="pa-0">
              <v-radio-group
                v-model="form.corporate_designation_type"
                :disabled="isFixedCorporationType"
                class="pa-0"
                row
              >
                <v-radio
                  label="事業者名の前に表示"
                  value="position_before"
                />
                <v-radio
                  label="事業者名の後ろに表示"
                  value="position_after"
                />
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- 事業者名 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>事業者名</strong>
            </v-col>
            <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: true, max: 60 }"
                  name="事業者名"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="form.emission_name"
                    :error-messages="errors"
                    outlined
                    dense
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span class="ml-1">
                        ({{ form.emission_name?.length || 0 }} / 60)
                      </span>
                    </template>
                  </v-text-field>
                </validation-provider>
                <p class="red--text text-caption">
                  ※「株式会社」「医療法人」等の組織種別は入力しない。支店単位、工場単位で加入する場合の支店名、工場名は支店名に入力してください。<br>
                  個人事業主（氏名で登録）の場合は代表者の氏名を入力してください。
                </p>
            </v-col>
          </v-row>

          <!-- 事業者名（フリガナ） -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>事業者名（フリガナ）</strong>
            </v-col>
            <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: true, katakana_only: true, max: 60 }"
                  name="事業者名フリガナ"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="form.emission_name_kana"
                    :error-messages="errors"
                    outlined
                    dense
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span class="ml-1">
                        ({{ form.emission_name_kana?.length || 0 }} / 60)
                      </span>
                    </template>
                  </v-text-field>
                </validation-provider>
            </v-col>
          </v-row>

          <!-- 事業所名 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>事業所名</strong>
            </v-col>
            <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ max: 60 }"
                  name="事業所名"
                >
                  <v-text-field
                    v-model="form.emission_location_name"
                    :error-messages="errors"
                    outlined
                    dense
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span class="ml-1">
                        ({{ form.emission_location_name?.length || 0 }} / 60)
                      </span>
                    </template>
                  </v-text-field>
                </validation-provider>
                <p class="red--text text-caption">
                  ※支店・店舗・工場単位で加入する場合は支店名・店舗名・工場名を入力。<br>
                  例1)「〇〇株式会社東京支店」で加入する場合、「東京支店」のみを入力。<br>
                  例2)「医療法人△△会　××クリニック」の場合、「××クリニック」のみを入力
                </p>
            </v-col>
          </v-row>

          <!-- 事業所名（フリガナ） -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>事業所名（フリガナ）</strong>
            </v-col>
            <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ katakana_only: true, max: 60 }"
                  name="事業所名フリガナ"
                >
                  <v-text-field
                    v-model="form.emission_location_name_kana"
                    :error-messages="errors"
                    outlined
                    dense
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span class="ml-1">
                        ({{ form.emission_location_name_kana?.length || 0 }} / 60)
                      </span>
                    </template>
                  </v-text-field>
                </validation-provider>
            </v-col>
          </v-row>

          <v-divider class="my-8" />

          <!-- 代表者名 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>代表者名</strong>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, max: 10 }"
                name="代表者姓"
                class="requiredMark">
                <v-text-field
                  v-model="form.representative_last_name"
                  :error-messages="errors"
                  outlined
                  dense
                  placeholder="姓"
                  persistent-placeholder
                >
                 <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.representative_last_name?.length || 0 }} / 10)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, max: 10 }"
                name="名"
                class="requiredMark">
                <v-text-field
                  v-model="form.representative_first_name"
                  :error-messages="errors"
                  outlined
                  dense
                  placeholder="名"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.representative_first_name?.length || 0 }} / 10)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!-- 代表者（フリガナ） -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>代表者（フリガナ）</strong>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, katakana_only: true, max: 20 }"
                name="代表者姓カナ"
                class="requiredMark">
                <v-text-field
                  v-model="form.representative_last_name_kana"
                  :error-messages="errors"
                  outlined
                  dense
                  placeholder="セイ"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.representative_last_name_kana?.length || 0 }} / 20)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, katakana_only: true, max: 20}"
                name="代表者名カナ"
                class="requiredMark">
                <v-text-field
                  v-model="form.representative_first_name_kana"
                  :error-messages="errors"
                  outlined
                  dense
                  placeholder="メイ"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.representative_first_name_kana?.length || 0 }} / 20)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!-- 郵便番号 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>郵便番号</strong>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, zip_code: true, max: 8 }"
                name="郵便番号"
                class="requiredMark">
                <v-text-field
                  v-model="form.zip_code"
                  :error-messages="errors"
                  outlined
                  dense
                  placeholder="100-0005"
                  persistent-placeholder
                  hint="ハイフンを含めて入力してください"
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.zip_code?.length || 0 }} / 8)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <zip-code-search
                :zipCode="form.zip_code"
                @zipAddress="setZipAddress"
              />
              &nbsp;
              <v-btn
                outlined
                small
                @click="searchZipButtonClickEvent"
              >
                住所→郵便番号
              </v-btn>
            </v-col>
          </v-row>

          <!-- 都道府県・市区町村 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>都道府県</strong>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: true }"
                  class="requiredMark"
                  name="都道府県"
                >
                  <v-autocomplete
                    v-model="form.prefecture_code"
                    :error-messages="errors"
                    :items="prefList"
                    dense
                    hide-details="auto"
                    item-text="text"
                    item-value="value"
                    outlined
                    label=" "
                    persistent-placeholder
                    placeholder="例）東京都"
                  >
                  </v-autocomplete>
                </validation-provider>
            </v-col>
            <v-col cols="12" md="1" class="d-flex justify-center">
              <strong>市区町村</strong>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, max: 20 }"
                name="市区町村"
                class="requiredMark">
                <v-text-field
                  v-model="form.address_1"
                  :error-messages="errors"
                  outlined
                  dense
                  persistent-placeholder
                  placeholder="例）中央区"
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.address_1?.length || 0 }} / 20)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!-- 町域 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>町域</strong>
            </v-col>
            <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ max: 40 }"
                  name="町域"
                >
                  <v-text-field
                    v-model="form.address_2"
                    :error-messages="errors"
                    outlined
                    dense
                    persistent-placeholder
                    placeholder="例）日本橋兜町"
                  >
                    <template v-slot:label>
                      <span class="ml-1">
                        ({{ form.address_2?.length || 0 }} / 40)
                      </span>
                    </template>
                  </v-text-field>
                </validation-provider>
            </v-col>
          </v-row>

          <!-- 詳細住所 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>詳細住所</strong>
            </v-col>
            <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ max: 40 }"
                  name="詳細住所"
                >
                  <v-text-field
                    v-model="form.address_3"
                    :error-messages="errors"
                    outlined
                    dense
                    persistent-placeholder
                    placeholder="例）１−２−３　○○ビル○階"
                  >
                    <template v-slot:label>
                      <span class="ml-1">
                        ({{ form.address_3?.length || 0 }} / 40)
                      </span>
                    </template>
                  </v-text-field>
                </validation-provider>
            </v-col>
          </v-row>

          <!-- 電話番号 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>電話番号</strong>
            </v-col>
            <v-col cols="12" md="9">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, numeric_hyphen_only: true, min: 2, max: 15 }"
                name="電話番号"
                class="requiredMark">
                <v-text-field
                  v-model="form.phone_number"
                  :error-messages="errors"
                  outlined
                  dense
                  persistent-placeholder
                  hint="電話番号を「-」ハイフン「( )」込みで入力します"
                  placeholder="例）000-0000-0000"
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.phone_number?.length || 0 }} / 15)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <v-divider class="my-8" />

          <!-- 担当者セクション -->
          <v-row>
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="9">
              <p class="red--text text-caption mb-4">
                ※　事務担当者は代表者と異なる場合のみ記入ください。
              </p>
              <v-checkbox
                v-model="form.same_as_representative"
                label="担当者名は代表者名と同一のため入力不要"
                @change="toggleSameAsRepresentative"
              />
            </v-col>
          </v-row>

          <!-- ご担当者名 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>ご担当者名</strong>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="form.same_as_representative ? {} : { required: true, max: 10 }"
                name="ご担当者姓"
                class="requiredMark">
                <v-text-field
                  v-model="form.contact_last_name"
                  :error-messages="errors"
                  outlined
                  dense
                  :disabled="form.same_as_representative"
                  placeholder="姓"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.contact_last_name?.length || 0 }} / 10)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="form.same_as_representative ? {} : { required: true, max: 10 }"
                name="ご担当者名"
                class="requiredMark">
                <v-text-field
                  v-model="form.contact_first_name"
                  :error-messages="errors"
                  outlined
                  dense
                  :disabled="form.same_as_representative"
                  placeholder="名"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.contact_first_name?.length || 0 }} / 10)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!-- ご担当者名（フリガナ） -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>ご担当者名（フリガナ）</strong>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="form.same_as_representative ? {} : { required: true, katakana_only: true, max: 20 }"
                name="ご担当者姓カナ"
                class="requiredMark">
                <v-text-field
                  v-model="form.contact_last_name_kana"
                  :error-messages="errors"
                  outlined
                  dense
                  :disabled="form.same_as_representative"
                  placeholder="セイ"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.contact_last_name_kana?.length || 0 }} / 20)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="form.same_as_representative ? {} : { required: true, katakana_only: true, max: 20 }"
                name="ご担当者名カナ"
                class="requiredMark">
                <v-text-field
                  v-model="form.contact_first_name_kana"
                  :error-messages="errors"
                  outlined
                  dense
                  :disabled="form.same_as_representative"
                  placeholder="メイ"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.contact_first_name_kana?.length || 0 }} / 20)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!-- 担当者電話番号 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>電話番号</strong>
            </v-col>
            <v-col cols="12" md="9">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ numeric_hyphen_only: true, min: 2, max: 15 }"
                name="担当者電話番号"
              >
                <v-text-field
                  v-model="form.contact_phone_number"
                  :error-messages="errors"
                  outlined
                  dense
                  :disabled="form.same_as_representative"
                  persistent-placeholder
                  hint="電話番号を「-」ハイフン「( )」込みで入力します"
                  placeholder="例）000-0000-0000"
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.contact_phone_number?.length || 0 }} / 15)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!-- メールアドレス -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>メールアドレス</strong>
            </v-col>
            <v-col cols="12" md="9">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, email: true, max: 255 }"
                name="メールアドレス"
                class="requiredMark"
              >
                <v-text-field
                  v-model="form.email"
                  :error-messages="errors"
                  outlined
                  dense
                  placeholder="emission@dx-e.jp"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.email?.length || 0 }} / 255)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
              <p class="red--text text-caption">
                ※　登録されたメールアドレスは、JWセンターからの手続きやシステム等（ログインパスワード）に関する重要なお知らせの配信先となります。
              </p>
            </v-col>
          </v-row>

          <!-- 処理業者 -->
          <v-row>
            <v-col cols="12" md="3">
              <strong>処理業者</strong>
            </v-col>
            <v-col cols="12" md="9" class="d-flex align-center">
              <span class="text-body-1">
                {{ form.transport_name || '未設定' }}
              </span>
            </v-col>
          </v-row>

          <v-divider class="my-8" />

          <!-- 業種 -->
          <v-row>
            <v-col cols="12">
              <strong class="d-block mb-4">業種</strong>

              <!-- 大分類選択 -->
              <v-row>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="業種大分類"
                  >
                    <v-select
                      v-model="selectedMajorCategory"
                      :items="majorCategories"
                      item-text="label"
                      item-value="value"
                      :error-messages="errors"
                      outlined
                      dense
                      label="大分類を選択してください"
                      placeholder="選択してください"
                      persistent-placeholder
                      @change="form.industry_code = null"
                    >
                      <template v-slot:append>
                        <v-icon>mdi-chevron-down</v-icon>
                      </template>
                    </v-select>
                  </validation-provider>
                </v-col>
              </v-row>

              <!-- 業種選択 -->
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true }"
                name="業種"
              >
                <v-radio-group
                  v-model="form.industry_code"
                  :error-messages="errors"
                  
                >
                  <p v-if="!selectedMajorCategory" class="text-caption grey--text mb-0">
                    ※ まず大分類を選択してください
                  </p>
                  <v-row v-else>
                    <v-col cols="12" md="6">
                      <v-radio
                        v-for="industry in industriesLeft"
                        :key="industry.value"
                        :label="industry.label"
                        :value="industry.value"
                        hide-details
                        class="mt-2"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-radio
                        v-for="industry in industriesRight"
                        :key="industry.value"
                        :label="industry.label"
                        :value="industry.value"
                        hide-details
                        class="mt-2"
                      />
                    </v-col>
                  </v-row>
                </v-radio-group>
              </validation-provider>
            </v-col>
          </v-row>

          <v-divider class="my-8" />

          <!-- 公開設定 -->
          <v-row>
            <v-col cols="12">
              <p class="mb-4">
                JWNETで加入者情報の公開をご希望の方は以下のご記入もお願い致します。
              </p>
              <v-radio-group v-model="form.visibility_type">
                <v-radio
                  label="公開を希望しません。"
                  value="not_public"
                />
                <v-radio
                  label="加入者名のみ公開を希望します。"
                  value="name_only"
                />
                <v-radio
                  label="加入者名と、以下のURLにて加入者情報の公開を希望します。"
                  value="name_and_profile"
                />
              </v-radio-group>
              <validation-provider
                v-if="form.visibility_type === 'name_and_profile'"
                v-slot="{ errors }"
                :rules="form.visibility_type === 'name_and_profile' ? { required: true, max: 255 } : {}"
                name="公開URL"
                class="requiredMark"
              >
                <v-text-field
                  v-model="form.visibility_url"
                  :error-messages="errors"
                  outlined
                  dense
                  placeholder="https://"
                  persistent-placeholder
                  class="mt-4"
                >
                  <template v-slot:label>
                    <span class="ml-1">
                      ({{ form.visibility_url?.length || 0 }} / 255)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!-- 注意事項 -->
          <v-row class="mb-6">
            <v-col cols="12">
              <v-card outlined class="pa-4">
                <p class="font-weight-bold mb-2">■注意事項</p>
                <p class="text-caption mb-2">
                  ・DXE株式会社を利用代表者として加入した加入者番号は、DXEシステムを利用した取引のみで使用可能です。万が一、DXEシステムを利用しない取引による使用が明らかになった場合はJWNETからの請求に基づいて別途使用料をお支払頂くことになりますので予めご了承下さい。
                </p>
                <p class="text-caption mb-2">
                  ・DXE株式会社を利用代表者として加入した加入者番号が、加入後18ヶ月に亘りDXEシステムの利用がない状態が継続した場合、次に到来する12月末時点をもって、団体加入取消しの手続きを行うものとします。
                </p>
                <p class="text-caption mb-2">
                  ・連絡先メールアドレスには仮登録メールを送信しますのでご記入ください。ご記入いただけない場合は、受付出来かねますのでご了承ください。
                </p>
                <p class="text-caption mb-2">
                  ・お申込み後は弊社にて順次手続きを致します。手続きが完了しますと連絡先メールアドレス宛で加入者番号、仮パスワードのメールが届きますのでご確認ください。通常1～2週間で手続きは完了致しますが、メールが届かない場合はDXE株式会社にお問い合わせください。
                </p>
                <p class="text-caption">
                  ・加入後に加入証が必要な場合は、JWNETにログインしてお客様自身にて印刷いただきますようお願い致します。
                </p>
              </v-card>
            </v-col>
          </v-row>

          <!-- フッターボタン -->
          <v-row class="mt-8">
            <v-col cols="6">
              <v-btn
                block
                large
                outlined
                @click="goBack"
              >
                戻る
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                block
                large
                color="primary"
                :disabled="isValidating"
                :loading="isValidating"
                @click="submit"
              >
                確認画面へ進む
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>

    </v-container>
    </validation-observer>
    <search-zip-modal-modal
      :enable="enableSearchZipModal"
      :initial-prefecture-code="form.prefecture_code"
      :initial-city-name="form.address_1"
      :initial-town-name="form.address_2"
      @reflectFullCallback="reflectFullCallback"
      @reflectZipCallback="reflectZipCallback"
      @closeCallback="closeModal"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ZipCodeSearch from '@/components/ZipCodeSearch'
import PrefectureList from '@/mixins/PrefectureList'
import SearchZipModalModal from "@/driver/components/SearchZipModal.vue";
import CorporationTypeMixin from "@/mixins/CorporationTypeMixin";

export default {
  name: 'RegistrationForm',
  components: {
    SearchZipModalModal,
    ZipCodeSearch
  },
  mixins: [PrefectureList, CorporationTypeMixin],
  props: {
    formData: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      valid: true,
      isValidating: false,
      form: this.formData ? { ...this.formData } : {
        jwnet_name: null,
        corporation_code: null,
        corporate_designation_type: 'position_before',
        emission_name: null,
        emission_name_kana: null,
        emission_location_name: null,
        emission_location_name_kana: null,
        representative_last_name: null,
        representative_first_name: null,
        representative_last_name_kana: null,
        representative_first_name_kana: null,
        zip_code: null,
        prefecture_code: null,
        address_1: null,
        address_2: null,
        address_3: null,
        phone_number: null,
        same_as_representative: false,
        contact_last_name: null,
        contact_first_name: null,
        contact_last_name_kana: null,
        contact_first_name_kana: null,
        contact_phone_number: null,
        email: null,
        transport_name: null,
        industry_code: null,
        visibility_type: 'private',
        visibility_url: null
      },
      majorCategories: [
        { label: '農業・林業・漁業', value: 'agriculture_forestry_fisheries' },
        { label: '鉱業・採石業', value: 'mining' },
        { label: '建設業', value: 'construction' },
        { label: '製造業', value: 'manufacturing' },
        { label: '電気・ガス・熱・水', value: 'electricity_gas_heat_water' },
        { label: '情報通信業', value: 'information_communication' },
        { label: '運輸業・郵便業', value: 'transport_postal' },
        { label: '卸売業・小売業', value: 'wholesale_retail' },
        { label: '金融業・保険業', value: 'finance_insurance' },
        { label: '不動産・物品賃貸', value: 'real_estate_rental' },
        { label: '学術研究・専門サービス', value: 'academic_professional' },
        { label: '宿泊・飲食サービス', value: 'accommodation_food' },
        { label: '生活関連・娯楽', value: 'lifestyle_entertainment' },
        { label: '教育・学習支援', value: 'education' },
        { label: '医療・福祉', value: 'medical_welfare' },
        { label: 'サービス', value: 'services' },
        { label: '公務', value: 'public_service' },
        { label: 'その他', value: 'others' }
      ],
      industriesList: [
        { label: '農業', value: 'A0100', category: 'agriculture_forestry_fisheries' },
        { label: '林業', value: 'A0200', category: 'agriculture_forestry_fisheries' },
        { label: '漁業（水産養殖業を除く）', value: 'B0300', category: 'agriculture_forestry_fisheries' },
        { label: '水産養殖業', value: 'B0400', category: 'agriculture_forestry_fisheries' },
        { label: '鉱業，採石業，砂利採取業', value: 'C0500', category: 'mining' },
        { label: '総合工事業', value: 'D0600', category: 'construction' },
        { label: '職別工事業（設備工事業を除く）', value: 'D0700', category: 'construction' },
        { label: '設備工事業', value: 'D0800', category: 'construction' },
        { label: '食料品製造業', value: 'E0900', category: 'manufacturing' },
        { label: '飲料・たばこ・飼料製造業', value: 'E1000', category: 'manufacturing' },
        { label: '繊維工業', value: 'E1100', category: 'manufacturing' },
        { label: '木材・木製品製造業（家具を除く）', value: 'E1200', category: 'manufacturing' },
        { label: '家具・装備品製造業', value: 'E1300', category: 'manufacturing' },
        { label: 'パルプ・紙・紙加工品製造業', value: 'E1400', category: 'manufacturing' },
        { label: '印刷・同関連業', value: 'E1500', category: 'manufacturing' },
        { label: '化学工業', value: 'E1600', category: 'manufacturing' },
        { label: '石油製品・石炭製品製造業', value: 'E1700', category: 'manufacturing' },
        { label: 'プラスチック製品製造業（別掲を除く）', value: 'E1800', category: 'manufacturing' },
        { label: 'ゴム製品製造業', value: 'E1900', category: 'manufacturing' },
        { label: 'なめし革・同製品・毛皮製造業', value: 'E2000', category: 'manufacturing' },
        { label: '窯業・土石製品製造業', value: 'E2100', category: 'manufacturing' },
        { label: '鉄鋼業', value: 'E2200', category: 'manufacturing' },
        { label: '非鉄金属製造業', value: 'E2300', category: 'manufacturing' },
        { label: '金属製品製造業', value: 'E2400', category: 'manufacturing' },
        { label: 'はん用機械器具製造業', value: 'E2500', category: 'manufacturing' },
        { label: '生産用機械器具製造業', value: 'E2600', category: 'manufacturing' },
        { label: '業務用機械器具製造業', value: 'E2700', category: 'manufacturing' },
        { label: '電子部品・デバイス・電子回路製造業', value: 'E2800', category: 'manufacturing' },
        { label: '電気機械器具製造業', value: 'E2900', category: 'manufacturing' },
        { label: '情報通信機械器具製造業', value: 'E3000', category: 'manufacturing' },
        { label: '輸送用機械器具製造業', value: 'E3100', category: 'manufacturing' },
        { label: 'その他の製造業', value: 'E3200', category: 'manufacturing' },
        { label: '電気業', value: 'F3300', category: 'electricity_gas_heat_water' },
        { label: 'ガス業', value: 'F3400', category: 'electricity_gas_heat_water' },
        { label: '熱供給業', value: 'F3500', category: 'electricity_gas_heat_water' },
        { label: '水道業', value: 'F3600', category: 'electricity_gas_heat_water' },
        { label: '通信業', value: 'G3700', category: 'information_communication' },
        { label: '放送業', value: 'G3800', category: 'information_communication' },
        { label: '情報サービス業', value: 'G3900', category: 'information_communication' },
        { label: 'インターネット附随サービス業', value: 'G4000', category: 'information_communication' },
        { label: '映像・音声・文字情報制作業', value: 'G4100', category: 'information_communication' },
        { label: '鉄道業', value: 'H4200', category: 'transport_postal' },
        { label: '道路旅客運送業', value: 'H4300', category: 'transport_postal' },
        { label: '道路貨物運送業', value: 'H4400', category: 'transport_postal' },
        { label: '水運業', value: 'H4500', category: 'transport_postal' },
        { label: '航空運輸業', value: 'H4600', category: 'transport_postal' },
        { label: '倉庫業', value: 'H4700', category: 'transport_postal' },
        { label: '運輸に附帯するサービス業', value: 'H4800', category: 'transport_postal' },
        { label: '郵便業（信書便事業を含む）', value: 'H4900', category: 'transport_postal' },
        { label: '各種商品卸売業', value: 'I5000', category: 'wholesale_retail' },
        { label: '繊維・衣服等卸売業', value: 'I5100', category: 'wholesale_retail' },
        { label: '飲食料品卸売業', value: 'I5200', category: 'wholesale_retail' },
        { label: '建築材料，鉱物・金属材料等卸売業', value: 'I5300', category: 'wholesale_retail' },
        { label: '機械器具卸売業', value: 'I5400', category: 'wholesale_retail' },
        { label: 'その他の卸売業', value: 'I5500', category: 'wholesale_retail' },
        { label: '各種商品小売業', value: 'I5600', category: 'wholesale_retail' },
        { label: '織物・衣服・身の回り品小売業', value: 'I5700', category: 'wholesale_retail' },
        { label: '飲食料品小売業', value: 'I5800', category: 'wholesale_retail' },
        { label: '機械器具小売業', value: 'I5900', category: 'wholesale_retail' },
        { label: 'その他の小売業', value: 'I6000', category: 'wholesale_retail' },
        { label: '無店舗小売業', value: 'I6100', category: 'wholesale_retail' },
        { label: '銀行業', value: 'J6200', category: 'finance_insurance' },
        { label: '協同組織金融業', value: 'J6300', category: 'finance_insurance' },
        { label: '貸金業，クレジットカード業等非預金信用機関', value: 'J6400', category: 'finance_insurance' },
        { label: '金融商品取引業，商品先物取引業', value: 'J6500', category: 'finance_insurance' },
        { label: '補助的金融業等', value: 'J6600', category: 'finance_insurance' },
        { label: '保険業（保険媒介代理業，保険サービス業を含む）', value: 'J6700', category: 'finance_insurance' },
        { label: '不動産取引業', value: 'K6800', category: 'real_estate_rental' },
        { label: '不動産賃貸業・管理業', value: 'K6900', category: 'real_estate_rental' },
        { label: '物品賃貸業', value: 'K7000', category: 'real_estate_rental' },
        { label: '学術・開発研究機関', value: 'L7100', category: 'academic_professional' },
        { label: '専門サービス業（他に分類されないもの）', value: 'L7200', category: 'academic_professional' },
        { label: '広告業', value: 'L7300', category: 'academic_professional' },
        { label: '技術サービス業（他に分類されないもの）', value: 'L7400', category: 'academic_professional' },
        { label: '宿泊業', value: 'M7500', category: 'accommodation_food' },
        { label: '飲食店', value: 'M7600', category: 'accommodation_food' },
        { label: '持ち帰り・配達飲食サービス業', value: 'M7700', category: 'accommodation_food' },
        { label: '洗濯・理容・美容・浴場業', value: 'N7800', category: 'lifestyle_entertainment' },
        { label: 'その他の生活関連サービス業', value: 'N7900', category: 'lifestyle_entertainment' },
        { label: '娯楽業', value: 'N8000', category: 'lifestyle_entertainment' },
        { label: '学校教育', value: 'O8100', category: 'education' },
        { label: 'その他の教育，学習支援業', value: 'O8200', category: 'education' },
        { label: '医療業', value: 'P8300', category: 'medical_welfare' },
        { label: '保健衛生', value: 'P8400', category: 'medical_welfare' },
        { label: '社会保険・社会福祉・介護事業', value: 'P8500', category: 'medical_welfare' },
        { label: '郵便局', value: 'Q8600', category: 'services' },
        { label: '協同組合（他に分類されないもの）', value: 'Q8700', category: 'services' },
        { label: '廃棄物処理業', value: 'R8800', category: 'services' },
        { label: '自動車整備業', value: 'R8900', category: 'services' },
        { label: '機械等修理業（別掲を除く）', value: 'R9000', category: 'services' },
        { label: '職業紹介・労働者派遣業', value: 'R9100', category: 'services' },
        { label: 'その他の事業サービス業', value: 'R9200', category: 'services' },
        { label: '政治・経済・文化団体', value: 'R9300', category: 'public_service' },
        { label: '宗教', value: 'R9400', category: 'public_service' },
        { label: 'その他のサービス業', value: 'R9500', category: 'others' },
        { label: '外国公務', value: 'R9600', category: 'public_service' },
        { label: '国家公務', value: 'S9700', category: 'public_service' },
        { label: '地方公務', value: 'S9800', category: 'public_service' }
      ],
      selectedMajorCategory: null,
      enableSearchZipModal: false,
    }
  },
  computed: {
    prefectures() {
      return this.prefList.map(pref => pref.text)
    },
    filteredIndustries() {
      if (!this.selectedMajorCategory) {
        return []
      }
      return this.industriesList.filter(industry => industry.category === this.selectedMajorCategory)
    },
    industriesLeft() {
      const half = Math.ceil(this.filteredIndustries.length / 2)
      return this.filteredIndustries.slice(0, half)
    },
    industriesRight() {
      const half = Math.ceil(this.filteredIndustries.length / 2)
      return this.filteredIndustries.slice(half)
    },
    jwnetName() {
      const org = this.getCorporationTypeText(this.form.corporation_code) || ''
      const name = this.form.emission_name || ''
      const office = this.form.emission_location_name || ''
      let jwnetName = ''
      if (this.isFixedCorporationType) {
        jwnetName = `${name}　${office}`.trim()
      } else if (this.form.corporate_designation_type === 'position_before') {
        jwnetName = `${org}${name}　${office}`.trim()
      } else {
        jwnetName = `${name}${org}　${office}`.trim()
      }
      return jwnetName
    },
    isFixedCorporationType () {
      return ['00', '99', '999'].includes(this.form.corporation_code);
    },
  },
  watch: {
    isFixedCorporationType (value) {
      if (value ) {
        this.form.corporate_designation_type = 'position_before';
      }
    },
    'form.industry_code': {
      handler(newCode) {
        if (newCode && !this.selectedMajorCategory) {
          const industry = this.industriesList.find(i => i.value === newCode)
          if (industry) {
            this.selectedMajorCategory = industry.category
          }
        }
      },
      immediate: true
    },
    'form.representative_last_name'() {
      this.syncContactFromRepresentative()
    },
    'form.representative_first_name'() {
      this.syncContactFromRepresentative()
    },
    'form.representative_last_name_kana'() {
      this.syncContactFromRepresentative()
    },
    'form.representative_first_name_kana'() {
      this.syncContactFromRepresentative()
    },
    'form.phone_number'() {
      this.syncContactFromRepresentative()
    },
    'form.same_as_representative'(value) {
      if (value) {
        this.syncContactFromRepresentative()
      }
    },
    formData: {
      handler(newData) {
        if (newData) {
          this.form = { ...newData }
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('EdiRequestUnsubscribed', {
      validateRequest: 'validate',
      validateEditRequest: 'validateEdit',
    }),
    ...mapActions('snackbar', {
      showError: 'showError'
    }),
    getCorporationTypeText(code) {
      const corporation_type = this.corporationTypeBy(code);
      return corporation_type ? corporation_type.text : ''
    },
    setZipAddress(content) {
      const prefecture = this.prefList.find(p => p.text === content.prefecture_code || p.value == String(content.pref_code));
      if (prefecture) {
        this.form.prefecture_code = prefecture.value;
      }
      this.form.address_1= content.locality;
      this.form.address_2 = content.street;
    },
    syncContactFromRepresentative() {
      if (!this.form.same_as_representative) return

      this.form.contact_last_name = this.form.representative_last_name || ''
      this.form.contact_first_name = this.form.representative_first_name || ''
      this.form.contact_last_name_kana = this.form.representative_last_name_kana || ''
      this.form.contact_first_name_kana = this.form.representative_first_name_kana || ''
      this.form.contact_phone_number = this.form.phone_number || ''
    },
    toggleSameAsRepresentative() {
      if (this.form.same_as_representative) {
        this.syncContactFromRepresentative()
      } else {
        this.form.contact_last_name = ''
        this.form.contact_first_name = ''
        this.form.contact_last_name_kana = ''
        this.form.contact_first_name_kana = ''
        this.form.contact_phone_number = ''
      }
    },
    submit() {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if (result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation() {
      this.isValidating = true
      this.form.jwnet_name = this.jwnetName
      const formData = { ...this.form }

      // visibility_url をエンコード
      if (formData.visibility_url) {
        formData.visibility_url = encodeURIComponent(formData.visibility_url)
      }

      const payload = {
        emission_request: formData
      }

      if (this.isNew) {
        // 新規登録の場合
        const token = this.$route.params.token
        this.validateRequest({ token, data: payload }).then(() => {
          this.$emit('submit', this.form)
        }).catch((error) => {
          this.handleValidationError(error)
        }).finally(() => {
          this.isValidating = false
        })
      } else {
        // 編集の場合
        const id = formData.id
        this.validateEditRequest({ id, data: payload }).then(() => {
          this.$emit('submit', this.form)
        }).catch((error) => {
          this.handleValidationError(error)
        }).finally(() => {
          this.isValidating = false
        })
      }
    },
    handleValidationError(error) {
      // サーバーサイドのバリデーションエラーを処理
      if (error.response && error.response.data && error.response.data.errors) {
        // エラーをvee-validateのフォーマットに変換
        const errors = {}
        const serverErrors = error.response.data.errors

        // エラーメッセージをフィールド名にマッピング
        Object.keys(serverErrors).forEach(key => {
          // emission_request.field_name の形式から field_name を抽出
          const fieldName = key.replace('emission_request.', '')
          // 配列の場合は最初のメッセージを取得、文字列の場合はそのまま使用
          const errorMessage = Array.isArray(serverErrors[key])
            ? serverErrors[key][0]
            : serverErrors[key]
          errors[fieldName] = errorMessage
        })

        // validation-observerにエラーをセット
        this.$refs.observer.setErrors(errors)

        // スクロールして最初のエラーフィールドを表示
        this.$nextTick(() => {
          this.$vuetify.goTo(0)
        })
      } else {
        // 汎用エラーメッセージを表示
        const errorMessage = error.response?.data?.result?.message
          || error.response?.data?.message
          || 'バリデーションエラーが発生しました。入力内容をご確認ください。'
        this.showError({ message: errorMessage })
      }
    },
    goBack() {
      // 編集モードの場合はAdminEdiRequestsに戻る
      if (this.isNew) {
        this.$router.push({ name: 'EdiRequestRegistrations', params: { token: this.$route.params.token } })
      } else {
        this.$router.push({ name: 'AdminEdiRequests' })
      }
    },
    searchZipButtonClickEvent () {
      this.enableSearchZipModal = true;
    },
    closeModal () {
      this.enableSearchZipModal = false;
    },
    reflectFullCallback (address) {
      this.form.zip_code = address.zip_code;
      this.form.prefecture_code = `${address.prefecture_code}`;
      this.form.address_1 = address.city ? address.city : '';
      this.form.address_2 = address.town ? address.town : '';
    },
    reflectZipCallback (zipCode) {
      this.form.zip_code = zipCode
    },
  }
}
</script>

<style scoped>
.text-none {
  text-transform: none !important;
}
</style>
